import get from 'lodash/get';
import { NEWS_BASE_URL } from 'services/news/configs';
import { fetcher, swrImmutableConfigs } from 'services/utils';
import useSWR from 'swr';

const useGetActiveNewsIds = () => {
  const { data, isValidating, error, mutate } = useSWR(`${NEWS_BASE_URL}/get-news-ids`, fetcher, swrImmutableConfigs(true));

  return {
    data: get(data, 'data', []),
    isLoading: isValidating,
    mutate,
    errorMessage: error
  };
};

export default useGetActiveNewsIds;
